import React from "react"
import { StaticImage } from "gatsby-plugin-image"
import { Link } from "gatsby"

const HomeAbout = () => {

    return (
        <section data-scrollax-parent="true" id="overview">
            <div className="section-subtitle"  data-scrollax="properties: { translateY: '-250px' }" > overview  <span>//</span></div>
                <div className="container">
                <div className="row">
                   
                    <div className="col-md-12">
                        <div className="main-about fl-wrap">
                            <h2> Overview  </h2>
                            <p>This website serves as the central reference point for all PragICTS standards, practices, and guidelines.</p>
                         
                            <p>It is designed to provide clear, up-to-date documentation and guidance across our engineering, operational, and quality processes. Whether you're part of the internal team, a new joiner, or an external partner, this site acts as your go-to resource for understanding how we work, what we expect, and how we ensure consistency and excellence across all our projects.</p>
             <div className="features-box-container fl-wrap">
               
  <div className="row">


    
    <div className="features-box col-md-6">
      <div className="time-line-icon">
        <i className="fal pragicts-infrastructure-icon"></i>
      </div>
      <a target="_blank" className="page-url" href="/general" ><h3>General</h3></a>
      <p>Public generic documents relating to PragICTS in General</p>
      <p><a className="prag-red" target="_blank" href="https://pragicts.com/">https://pragicts.com/</a></p>
    </div>

    <div className="features-box col-md-6">
      <div className="time-line-icon">
        <i className="fal pragicts-software-icon"></i>
      </div>
      <a target="_blank" className="page-url" href="/software-engineering"><h3>Software Engineering</h3></a>
      <p>Public generic documents relating to the PragICTS Software Engineering Vertical</p>
      <p><a className="prag-red" target="_blank" href="https://softwaredevelopment.pragicts.com/">https://softwaredevelopment.pragicts.com/</a></p>
    </div>

    <div className="features-box col-md-6">
      <div className="time-line-icon">
        <i className="fab pragicts-cloud-icon"></i>
      </div>
      <a target="_blank" className="page-url" href="/itops"><h3>IT Ops</h3></a>
      <p>Public generic documents relating to the PragICTS IT Operations Vertical</p>
      <p><a className="prag-red" target="_blank" href="https://itops.pragicts.com/">https://itops.pragicts.com/</a></p>
    </div>

    <div className="features-box col-md-6">
      <div className="time-line-icon">
        <i className="fal pragicts-infrastructure-icon"></i>
      </div>
      <a target="_blank" className="page-url" href="/cloudops"><h3>Cloud Ops</h3></a>
      <p>Public generic documents relating to the PragICTS Cloud Operations Vertical</p>
      <p><a className="prag-red" target="_blank" href="https://cloudops.pragicts.com/">https://cloudops.pragicts.com/</a></p>
    </div>

    <div className="features-box col-md-6">
      <div className="time-line-icon">
        <i className="fab pragicts-security-assurance-icon"></i>
      </div>
      <a target="_blank" className="page-url" href="/cyber-security-ops"><h3>Cyber Security Ops</h3></a>
      <p>Public generic documents relating to the PragICTS Cyber Security Operations Vertical</p>
      <p><a className="prag-red" target="_blank" href="https://cybersecops.pragicts.com/">https://cybersecops.pragicts.com/</a></p>
    </div>

  </div>
</div>






               
                       
                       {/*      <div className="features-box-container fl-wrap">
                                <div className="row">
                                    <div className="features-box col-md-6">
                                        <div className="time-line-icon">
                                            <i className="fal pragicts-software-icon"></i>
                                        </div>
                                        <Link to="/service/software-development"><h3>Software</h3></Link>
                                        <p>Software development and support services. Web (including websites), Mobile and Rich Client Applications.</p>
                                        <p><Link to="/service/software-development">More Details ...</Link></p>
                                    </div>
                                    <div className="features-box col-md-6">
                                        <div className="time-line-icon">
                                            <i className="fal pragicts-infrastructure-icon"></i>
                                        </div>
                                        <a target="_blank" href="https://infrastructure.pragicts.com"><h3>Infrastructure</h3></a>
                                        <p>Implementation, management, and support of ICT Infrastructure.  On-site, remote, hybrid, and on-call service models.</p>
                                        <p><a target="_blank" href="https://infrastructure.pragicts.com">More Details ...</a></p>
                                    </div>
                                    <div className="features-box col-md-6">
                                        <div className="time-line-icon">
                                            <i className="fab pragicts-cloud-icon"></i>
                                        </div>
                                        <a target="_blank" href="https://cloud.pragicts.com"><h3>Cloud</h3></a>
                                        <p>Provisioning, management, and support of cloud platforms. Amazon, Microsoft, Google, and other third parties.</p>
                                        <p><a target="_blank" href="https://cloud.pragicts.com">More Details ...</a></p>
                                    </div>
                                </div>
                            </div>  */}
                            {/* <a href="portfolio.html" className="btn float-btn flat-btn color-btn">My Portfolio</a> */}
                        </div>
                    </div>
                </div>
            </div>
           {/*     <div className="container">
                <div className="row">
                    <div className="col-md-8">

                    <div className="col-md-4">  <div class="clutch-widget" data-url="https://widget.clutch.co" data-widget-type="2" data-height="45" data-nofollow="true" data-expandifr="true" data-scale="100" data-clutchcompany-id="1504388"></div></div>
                    <div className="col-md-4">    <a href="https://www.designrush.com/agency/profile/pragicts" target="_blank"><StaticImage src="../images/home/designrush-accredited-agency-pragicts.png" className="highlights" ></StaticImage></a></div>

                    </div>
                </div>
            </div>*/}
            <div className="bg-parallax-module" data-position-top="90"  data-position-left="25" data-scrollax="properties: { translateY: '-250px' }"></div>
            <div className="bg-parallax-module" data-position-top="70"  data-position-left="70" data-scrollax="properties: { translateY: '150px' }"></div>
            <div className="sec-lines"></div>
        </section>
    )
}

export default HomeAbout
